import { render, staticRenderFns } from "./ProductPage3.vue?vue&type=template&id=009f1823&scoped=true"
import script from "./ProductPage3.vue?vue&type=script&lang=js"
export * from "./ProductPage3.vue?vue&type=script&lang=js"
import style0 from "./ProductPage3.vue?vue&type=style&index=0&id=009f1823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f1823",
  null
  
)

export default component.exports